import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import { BlindReceivePermissions } from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';
import GoToPoEnterReceipts from 'src/sections/enter_receipt/GoToPoEnterReceipts';
import InfoButton from 'src/sections/enter_receipt/custom_grid_cell/InfoButton';
import PoStatus from 'src/sections/enter_receipt/custom_grid_cell/PoStatus';
import OfflineSupplierCell from 'src/sections/enter_receipt/custom_grid_cell/cells/OfflineSupplierCell';

const usePoColumns = () => {
  const isBlindReceive = usePermission({ permissions: BlindReceivePermissions });

  const poColumns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'errors',
        title: '',
        width: 40,
        component: InfoButton,
        menu: false,
      },
      {
        field: 'poNum',
        title: 'PO #',
        filter: 'text',
        dataType: 'string',
        component: GoToPoEnterReceipts,
        menu: false,
      },
      {
        field: 'numberOfReceipts',
        title: '# of Receipts',
        filter: 'numeric',
        dataType: 'number',
        filterFormat: '#',
        component: OfflineSupplierCell,
        step: 1,
      },
      {
        field: 'poStatus',
        title: 'PO Status',
        component: PoStatus,
        filter: 'text',
        dataType: 'string',
      },
      {
        field: 'statusDate',
        title: 'Status Date',
        filter: 'date',
        format: '{0:MM/dd/yyyy}',
        dataType: 'date',
        component: OfflineSupplierCell,
      },
      {
        field: 'supplierName',
        title: 'Supplier Name',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'buyerName',
        title: 'Buyer',
        filter: 'text',
        component: OfflineSupplierCell,
        dataType: 'string',
      },
      {
        field: 'poSubject',
        title: 'Subject',
        filter: 'text',
        component: OfflineSupplierCell,
        dataType: 'string',
      },
      ...(isBlindReceive
        ? []
        : ([
            {
              field: 'poQty',
              title: 'PO Quantity',
              filter: 'numeric',
              dataType: 'number',
              filterFormat: 'n',
              component: OfflineSupplierCell,
              step: 1,
            },
            {
              field: 'receiptTTLQty',
              title: 'Total Qty Received',
              filter: 'numeric',
              dataType: 'number',
              filterFormat: 'n',
              component: OfflineSupplierCell,
              step: 1,
            },
          ] as GridColumn<any>[])),
    ],
    [isBlindReceive]
  );
  return poColumns;
};

export default usePoColumns;
